/**
 * [READ ONLY STORE]
 *
 * Global Site Data
 */

import siteData from "~/data/site.yaml";

export const state = () => {
    return siteData;
};
